import { Container, ContainerHeader, ContainerContent } from 'components/Containers/Containers'
import { useNavigate } from 'react-router-dom'
import { Button, Flex } from 'styling/GlobalStyles'
import { BodyText, TitleText } from 'styling/Typography'

export const Review = ({ setStep, setState, state, handleSave }: { setStep: (step: number) => void, setState?: any, state: any, handleSave: () => void }) => {

    const navigate = useNavigate()

    const handleBack = () => navigate(4)


    return <>


        <Flex column gap='1rem' >
            <Container>
                <ContainerHeader>
                    <TitleText>Identity</TitleText>
                </ContainerHeader>
                <ContainerContent>
                    <Flex column gap='1rem'>
                        <Flex gap='5rem' >
                            <BodyText grey >NAME</BodyText>
                            <BodyText  >Q1 Mill Throughput Push (copy) </BodyText>
                        </Flex>
                        <Flex gap='5rem' >
                            <BodyText grey >NOTES</BodyText>
                            <BodyText  >MTP-Q1-2026-COPY </BodyText>
                        </Flex>
                    </Flex>
                </ContainerContent>
            </Container>
            <Container>
                <ContainerHeader>
                    <TitleText>Scope</TitleText>
                </ContainerHeader>
                <ContainerContent>
                    <Flex column gap='1rem'>
                        <Flex gap='5rem' >
                            <BodyText grey >Site</BodyText>
                            <BodyText  >Q1 Mill Throughput Push (copy) </BodyText>
                        </Flex>
                        <Flex gap='5rem' >
                            <BodyText grey >DEPARTMENT</BodyText>
                            <BodyText  >MTP-Q1-2026-COPY </BodyText>
                        </Flex>
                        <Flex gap='5rem' >
                            <BodyText grey >TEAMS</BodyText>
                            <BodyText  >MTP-Q1-2026-COPY </BodyText>
                        </Flex>
                    </Flex>
                </ContainerContent>
            </Container>
            <Container>
                <ContainerHeader>
                    <TitleText>Recurrence</TitleText>
                </ContainerHeader>
                <ContainerContent>
                    <Flex column gap='1rem'>
                        <Flex gap='5rem' >
                            <BodyText grey >FREQUENCY</BodyText>
                            <BodyText  >Q1 Mill Throughput Push (copy) </BodyText>
                        </Flex>
                        <Flex gap='5rem' >
                            <BodyText grey >CADENCE</BodyText>
                            <BodyText  >MTP-Q1-2026-COPY </BodyText>
                        </Flex>
                        <Flex gap='5rem' >
                            <BodyText grey >SHIFTS</BodyText>
                            <BodyText  >MTP-Q1-2026-COPY </BodyText>
                        </Flex>
                    </Flex>
                </ContainerContent>
            </Container>
            <Container>
                <ContainerHeader>
                    <TitleText>Task Bindings</TitleText>
                </ContainerHeader>
                <ContainerContent>
                    <Flex column gap='1rem'>
                        <Flex gap='5rem' >
                            <BodyText grey >NAME</BodyText>
                            <BodyText  >Q1 Mill Throughput Push (copy) </BodyText>
                        </Flex>
                        <Flex gap='5rem' >
                            <BodyText grey >CODE</BodyText>
                            <BodyText  >MTP-Q1-2026-COPY </BodyText>
                        </Flex>
                    </Flex>
                </ContainerContent>
            </Container>

        </Flex>
        <Flex gap='1rem' alignEnd justend mt='32' >
            <Button onClick={handleBack}>Back</Button>
            <Button orange onClick={handleSave} >Save</Button>
        </Flex>
    </>
}